import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MonthReportResource } from '~/generated';
import { analyticsGetMonthReport } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type MonthReportParams = {
  year: number;
  month: number;
};

export const useMonthReport = (
  { year, month }: MonthReportParams,
  options?: Omit<
    UseQueryOptions<
      MonthReportResource,
      unknown,
      MonthReportResource,
      ['monthReport', number, number]
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['monthReport', year, month],
    queryFn: () =>
      extractData(analyticsGetMonthReport({ path: { year, month } })),
    ...options,
  });
};
